export enum RecordPersistenceMode {
    ALWAYS_PERSIST,
    NEVER_PERSIST,
    PERSIST_RECENTLY_CREATED
};
